//@flow strict
export const itemCount = 10;
